exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search {\n  padding-top: 68px;\n}\n.search-box > div:not(.ant-row) {\n  min-height: 62px;\n}\n.search-box .search-list-row-data-link.select {\n  background-color: #449AF8;\n}\n.search-info {\n  padding: 20px 0px;\n}\n.search-info-value {\n  color: #f00;\n  padding: 0px 2px;\n}\n.search-select-demotype {\n  width: 180px;\n  float: right;\n  margin: 20px 0px 10px;\n}\n.search-theme {\n  background: #fff;\n}\n.search-content::after {\n  content: \"\";\n  clear: both;\n  display: block;\n}\n.search-content-page {\n  text-align: right;\n  margin-right: 8.33333333%;\n  margin-bottom: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#1DA57A"}}!./src/style/search.less
// module id = 1430
// module chunks = 0